import { VEHICLE_PROFILES, type VehicleProfile } from '@klareospace/pharos-lib-types';

/**
 * `VEHICLE_PROFILES.PEDESTRIAN`'s label was deduplicated into `common.json` (its text matched the
 * onboarding wizard's vehicle option). `vehicleTemplates.profiles.${profile}` dynamic lookups must
 * resolve it through the explicit `common:` namespace prefix instead of the local `settings`
 * namespace.
 */
const VEHICLE_PROFILE_KEY_OVERRIDES: Partial<Record<VehicleProfile, string>> = {
  [VEHICLE_PROFILES.PEDESTRIAN]: 'common:fields.pedestrian',
};

/**
 * Resolves the i18n key for a `VehicleProfile` label — the override is namespace-qualified
 * (`common:`), the default stays relative to the local `settings` namespace the caller's `t` is
 * bound to.
 */
export function resolveVehicleProfileKey(profile: VehicleProfile): string {
  return VEHICLE_PROFILE_KEY_OVERRIDES[profile] ?? `vehicleTemplates.profiles.${profile}`;
}
